import { useEffect } from "react";
import { useSelector } from "react-redux";
import styling from "./components/style/main.scss?raw";
import SurveyFormContainer from "./components/molecules/SurveyFormContainer.jsx";
import FloatingActionTrigger from "./components/molecules/FloatingActionTrigger.jsx";
import FloatingWindow from "./components/organisms/FloatingWindow.jsx";
import {
    INTERNAL_PARAM,
    QUERY_PARAMS,
    ALLOWED_HOSTNAME,
} from "../constants.js";
import { operationHour } from "./services/apiService.js";
import { useDispatch } from "react-redux";
import { setFloatingContainerState } from "./features/componentStateSlice.js";
import {
    setLiveAgentFromCheckOph,
    setLiveAgentBusinessHourMsg,
} from "./features/liveAgentSlice.js";
import { setSelfServiceStatus } from "./features/sessionSlice.js";

export function App() {
    const host = document.getElementById("app");
    const shadowRoot = host.shadowRoot;
    const dispatch = useDispatch();
    const surveyFormState = useSelector(
        (state) => state.survey.surveyFormState
    );

    // Insert styling
    useEffect(() => {
        const marinaStyling = document.createElement("style");
        marinaStyling.setAttribute("type", "text/css");
        marinaStyling.textContent = styling;
        shadowRoot.appendChild(marinaStyling);
    }, [shadowRoot]);

    // Check Operation Hour
    useEffect(async () => {
        if (ALLOWED_HOSTNAME.includes(window.location.hostname)) {
            if (!QUERY_PARAMS.includes(INTERNAL_PARAM)) {
                const operationResponse = await operationHour();
                dispatch(
                    setLiveAgentFromCheckOph(
                        operationResponse.live_agent_available
                    )
                );
                dispatch(
                    setLiveAgentBusinessHourMsg(
                        operationResponse.business_hours_message
                    )
                );
                dispatch(
                    setSelfServiceStatus(operationResponse.is_self_service)
                );
                if (operationResponse.operation_hours === true)
                    dispatch(setFloatingContainerState(true));
            } else {
                dispatch(setFloatingContainerState(true));
            }
        }
    }, [shadowRoot]);

    return (
        <>
            <FloatingActionTrigger />
            <FloatingWindow />
            {surveyFormState && <SurveyFormContainer />}
        </>
    );
}
